<div style="background: #041028; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
  <img src="/assets/images/steelhaus-coming-soon.png" alt="Modern Stationary Bike" style="max-width: 600px; width: 100%; margin-bottom: 40px;">
</div>